import { useTranslation } from 'react-i18next'
import { leaveForReturnUrl } from '@/utils/editor/returnToOrderUrl'
import { Button, DarkImage } from '@/components'
import Flex from '@/components/priority/Flex/Flex'
import Text from '@/components/priority/Text/Text'

type EditUnauthorizedProps = {
  returnUrlProp?: string | null
  shouldCloseTab?: boolean
}

export const EditUnauthorized = ({
  returnUrlProp = null,
  shouldCloseTab = false,
}: EditUnauthorizedProps = {}): JSX.Element => {
  const { i18n } = useTranslation()
  // The callers pass the case's stored return URL, or `/` when the case has
  // none; only a stored URL leaves the app, through the one return-URL reader.
  const storedReturnUrl =
    returnUrlProp && !returnUrlProp.startsWith('/') ? returnUrlProp : null

  const handleReturnClick = (): void => {
    if (shouldCloseTab) {
      // For M3, close the current tab
      window.close()
    } else if (storedReturnUrl) {
      leaveForReturnUrl(storedReturnUrl, i18n.language)
    } else {
      // A full load: this page also renders outside the router (from `Auth`),
      // where a history push would do nothing.
      window.location.href = '/dashboard'
    }
  }

  const buttonText = shouldCloseTab ? 'Close Tab' : 'Return to Order'

  return (
    <Flex column align="center" justify="center" style={{ minHeight: '100vh' }}>
      <Flex align="center" justify="center" column>
        <DarkImage
          width="200px"
          alt="Messenger Dove Logo"
          src="messengerDoveLogo"
        />
        <Flex column align="center" margin="24px 0 0 0" maxWidth="600px">
          {/* @ts-expect-error - Legacy component props */}
          <Text as="h2" margin="0 0 16px 0" textAlign="center">
            Unable to edit order
          </Text>
          {/* @ts-expect-error - Legacy component props */}
          <Text textAlign="center" margin="0 0 24px 0">
            You may not have permission to edit this order, or there was an
            error with your request. Go back to the main order page and request
            edit access again. If the issue persists, please contact support.
          </Text>
          <Button center primary onClick={handleReturnClick}>
            {buttonText}
          </Button>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default EditUnauthorized
